export const WHITE_LABEL_BRANDS = {
  GRUPO_SIAYEC: "grupo-siayec",
  GRUPO_SIAYEC_ACT: "gs-act",
  INTEGRA: "integra",
  THINKSAFE: "thinksafe",
  RODHE: "rodhe",
  DEFAULT: "default",
};
